jQuery(document).ready(function ($) {
    function enableFormSubmitButton(event) {
        console.log(`${event.type}: enable`);

        if ($(this).find('.wpcf7-submit').attr('disabled') === 'disabled') {
            $(this).find('.wpcf7-submit').removeAttr('disabled');

            $(this).closest('.popup__content').scrollTop(0);
        }
    }

    function disableFormSubmitButton(event) {
        console.log(`${event.type}: disable`);
        $(this).find('.wpcf7-submit').attr('disabled', '');
    }

    $(document).on({
        'change wpcf7statuschanged': enableFormSubmitButton,
        'submit': disableFormSubmitButton,
    }, '.wpcf7-form')
});